'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AiRequiredRed = function (_React$Component) {
    _inherits(AiRequiredRed, _React$Component);

    function AiRequiredRed() {
        _classCallCheck(this, AiRequiredRed);

        return _possibleConstructorReturn(this, (AiRequiredRed.__proto__ || Object.getPrototypeOf(AiRequiredRed)).apply(this, arguments));
    }

    _createClass(AiRequiredRed, [{
        key: 'svgPath',
        value: function svgPath(strokeColor, strokeWidth) {
            return _react2.default.createElement(
                'g',
                null,
                _react2.default.createElement(
                    'g',
                    null,
                    _react2.default.createElement(
                        'g',
                        null,
                        _react2.default.createElement('path', { stroke: strokeColor, strokeWidth: strokeWidth, fill: '#FFFFFF', d: 'M43.5,9h-23C14.149,9,9,14.149,9,20.5v23C9,49.851,14.149,55,20.5,55h23C49.851,55,55,49.851,55,43.5v-23 C55,14.149,49.851,9,43.5,9L43.5,9z' }),
                        _react2.default.createElement(
                            'g',
                            null,
                            _react2.default.createElement('path', { stroke: strokeColor, strokeWidth: strokeWidth, fill: '#D0CFCE', d: 'M44,10c5.514,0,10,4.486,10,10v24c0,5.514-4.486,10-10,10H20c-5.514,0-10-4.486-10-10V20 c0-5.514,4.486-10,10-10H44 M44,8H20C13.373,8,8,13.373,8,20v24c0,6.627,5.373,12,12,12h24c6.627,0,12-5.373,12-12V20 C56,13.373,50.627,8,44,8L44,8z' })
                        )
                    ),
                    _react2.default.createElement('path', { stroke: strokeColor, strokeWidth: strokeWidth, fill: '#C32628', d: 'M34.714,22l-0.856,7.682l7.787-2.172l0.689,5.262l-7.1,0.5l4.656,6.201L35.152,42l-3.257-6.534l-2.86,6.492 l-4.927-2.484l4.614-6.201l-7.057-0.542l0.815-5.22l7.621,2.172L29.245,22H34.714z' })
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var strokeColor = this.props.strokeColor || 'white';
            var strokeWidth = this.props.strokeWidth || 0;
            var viewBox = '0 0 64 64';
            var style = {
                fontSize: '200%',
                verticalAlign: '-23%'
            };

            if (this.props.noPad) {
                viewBox = '8 8 48 48';
                style = {};
            }

            var props = _underscore2.default.omit(this.props, 'noPad', 'strokeColor');

            if (this.props.strokeWidth > 0) {
                return _react2.default.createElement(
                    _reactIconBase2.default,
                    _extends({ className: 'ai ai-required-red', viewBox: viewBox, style: style }, props),
                    this.svgPath(strokeColor, strokeWidth),
                    this.svgPath('white', 0)
                );
            } else {
                return _react2.default.createElement(
                    _reactIconBase2.default,
                    _extends({ className: 'ai ai-required-red', viewBox: viewBox, style: style }, props),
                    this.svgPath('white', 0)
                );
            }
        }
    }], [{
        key: 'propTypes',
        get: function get() {
            return Object.assign({}, _reactIconBase2.default.propTypes, {
                strokeColor: _propTypes2.default.string,
                strokeWidth: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
                noPad: _propTypes2.default.bool
            });
        }
    }]);

    return AiRequiredRed;
}(_react2.default.Component);

exports.default = AiRequiredRed;